import {
    SUPPORTING_DOCUMENTS,
    TCDWCL_EMPLOYMENT_DETAILS,
    TCDWCL_QUALIFICATION_DETAILS
} from 'common/application.const/Licence/MyLicence/TCDWCLLicence';

import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatTCDWCL = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let qualificationDetails = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.QualificationList && licenceDetails.QualificationList.length > 0) {
        qualificationDetails = licenceDetails?.QualificationList.map((value: any, i: number) => ({
            'certificate-type': value?.CertificateTypeDes ?? '-',
            'course-name': value?.CourseName ?? '-',
            'certificate-name': value?.CertificateName ?? '-',
            'date-passed': value?.DatePassed ?? '-'
        }));
    }

    licence = {
        id: 'telecommunication-cable-detection-worker-class-licence',
        formID: 'telecommunication-cable-detection-worker-class-licence',
        hasError: true,
        title: 'Licence Details',
        values: {
            [`${TCDWCL_QUALIFICATION_DETAILS}-list`]: qualificationDetails ?? [...qualificationDetails],

            [`${TCDWCL_EMPLOYMENT_DETAILS}-self-employed`]: licenceDetails?.EmploymentDetails?.IsSelfEmployed ?? '-',
        }
    };

    return licence;
};

const tcdwclPayload = {
    formatTCDWCL
};

export default tcdwclPayload;
